import axios from "@/axios";

const cleanParams = (params = {}) =>
  Object.entries(params).reduce((acc, [key, value]) => {
    if (value === undefined || value === null || value === "") return acc;
    acc[key] = value;
    return acc;
  }, {});

export const PromotionManagementApi = {
  getPromotions(params = {}) {
    return axios.get("/certilife/promotions", {
      params: cleanParams(params),
      showGlobalLoading: false,
    });
  },

  getPromotion(promotionId) {
    return axios.get(`/certilife/promotions/${promotionId}`, {
      showGlobalLoading: false,
    });
  },

  exportPromotions(params = {}) {
    return axios.post("/certilife/promotions/export", cleanParams(params), {
      responseType: "blob",
    });
  },

  getEntries(promotionId, params = {}) {
    return axios.get(`/certilife/promotions/${promotionId}/entries`, {
      params: cleanParams(params),
      showGlobalLoading: false,
    });
  },

  exportEntries(promotionId, payload = {}) {
    return axios.post(
      `/certilife/promotions/${promotionId}/entries/export`,
      cleanParams(payload),
      {
        responseType: "blob",
      },
    );
  },

  exportGlobalEntries(payload = {}) {
    return axios.post(
      "/certilife/promotion-entries/export",
      cleanParams(payload),
      {
        responseType: "blob",
      },
    );
  },

  getManufacturers(keyword = "") {
    return axios.post(
      "/companies/certi-admin/category-bind/manufacturers",
      {
        page: 1,
        limit: 500,
        search: "name",
        condition: keyword,
      },
      {
        showGlobalLoading: false,
      },
    );
  },
};

export const saveExcelBlob = (response, fallbackName) => {
  const disposition = response.headers?.["content-disposition"] || "";
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
  const fileName = utf8Match
    ? decodeURIComponent(utf8Match[1])
    : plainMatch?.[1] || fallbackName;
  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
